module.exports = __webpack_public_path__ + "static/media/colored-bell-alert.3c64ea39.svg";